import { BatchesPage } from "@/components/Batches/BatchesPage";

export function Batches() {
  return <BatchesPage />;
}
